import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import Select from "react-select";

function AssignRollNoModal({ open, onClose, student }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const currentDate = new Date().toISOString().split("T")[0];

  const sectionOptions = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
    { value: "C", label: "C" },
  ];

  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: {
      admissionChallanNo: "",
      feePaidOn: "",
      isFeePaid: false,
      admissionDate: "",
      section: null,
    },
  });

  useEffect(() => {
    reset();
  }, [reset]);

  const handleAssign = async (data) => {
    setIsSubmitting(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      toast.success("Roll No assigned successfully!");
      onClose();
    } catch (error) {
      toast.error("Error assigning roll no");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!open) return null;

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
        onClick={handleBackdropClick}
      >
        <div
          className="modal-dialog"
          style={{
            maxWidth: "600px",
            marginTop: "20px",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="modal-content"
            style={{
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="modal-header" style={{ padding: "12px 16px" }}>
              <h5 className="mb-0 fw-bold">Assign Roll No</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body" style={{ padding: "16px" }}>
              <form onSubmit={handleSubmit(handleAssign)}>
                <div className="row g-2">
                  {/* Left Column */}
                  <div className="col-md-6">
                    {/* Admission Challan No */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">
                        Admission Challan No
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        {...register("admissionChallanNo", {
                          required: "Admission Challan No is required",
                        })}
                        className={`form-control ${
                          errors.admissionChallanNo ? "is-invalid" : ""
                        }`}
                        placeholder="Enter challan no"
                        style={{ height: "38px" }}
                      />
                      {errors.admissionChallanNo && (
                        <div className="invalid-feedback">
                          {errors.admissionChallanNo.message}
                        </div>
                      )}
                    </div>

                    {/* Is Fee Paid Checkbox */}
                    <div className="mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          {...register("isFeePaid")}
                        />
                        <label className="form-check-label">Is Fee Paid</label>
                      </div>
                    </div>

                    {/* Fee Paid On */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">
                        Fee Paid On
                      </label>
                      <input
                        type="date"
                        {...register("feePaidOn")}
                        className={`form-control ${
                          errors.feePaidOn ? "is-invalid" : ""
                        }`}
                        style={{ height: "38px" }}
                      />
                      {errors.feePaidOn && (
                        <div className="invalid-feedback">
                          {errors.feePaidOn.message}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="col-md-6">
                    {/* Challan Issuance Date */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">
                        Challan Issuance Date
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={currentDate}
                        disabled
                        style={{
                          backgroundColor: "#f8f9fa",
                          height: "38px",
                        }}
                      />
                    </div>

                    {/* Admission Date */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">
                        Admission Date<span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        {...register("admissionDate", {
                          required: "Admission date is required",
                        })}
                        className={`form-control ${
                          errors.admissionDate ? "is-invalid" : ""
                        }`}
                        style={{ height: "38px" }}
                      />
                      {errors.admissionDate && (
                        <div className="invalid-feedback">
                          {errors.admissionDate.message}
                        </div>
                      )}
                    </div>

                    {/* Section */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">
                        Section<span className="text-danger">*</span>
                      </label>
                      <Controller
                        name="section"
                        control={control}
                        rules={{ required: "Section is required" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={sectionOptions}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption);
                            }}
                            onBlur={field.onBlur}
                            value={field.value}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            isClearable
                            placeholder="Select Section"
                            styles={{
                              control: (base) => ({
                                ...base,
                                height: "38px",
                                minHeight: "38px",
                                fontSize: "0.75rem",
                                borderRadius: "0.25rem",
                                border: "1px solid #ced4da",
                                padding: "0",
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                padding: "0 0.75rem",
                                height: "38px",
                                display: "flex",
                                alignItems: "center",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                lineHeight: "38px",
                              }),
                              input: (base) => ({
                                ...base,
                                margin: 0,
                                padding: 0,
                                lineHeight: "38px",
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                padding: "0 0.5rem",
                              }),
                              clearIndicator: (base) => ({
                                ...base,
                                padding: "0 0.5rem",
                              }),
                            }}
                          />
                        )}
                      />
                      {errors.section && (
                        <div className="invalid-feedback d-block">
                          {errors.section.message}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Bottom Row for Class and Center Name */}
                  <div className="col-12">
                    <div className="row g-2">
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">Class</label>
                        <input
                          type="text"
                          className="form-control"
                          value={student?.className || "N/A"}
                          disabled
                          style={{
                            backgroundColor: "#f8f9fa",
                            height: "38px",
                          }}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          Center Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={student?.centerName || "N/A"}
                          disabled
                          style={{
                            backgroundColor: "#f8f9fa",
                            color: "black",
                            fontWeight: "bold",
                            height: "38px",
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="col-12">
                    <div className="d-flex gap-2 justify-content-end pt-2 border-top">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={onClose}
                        disabled={isSubmitting}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary btn-sm"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              aria-hidden="true"
                            ></span>
                            Assigning...
                          </>
                        ) : (
                          "Assign"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" onClick={onClose}></div>
    </>
  );
}

export default AssignRollNoModal;
